import {Component, EventEmitter, Output} from '@angular/core';
import Color from "../../../products/models/colors";
import {capitalizeFirstLetter} from "../../../shared/helpers/string.helpers";

@Component({
  selector: 'app-color-filter',
  templateUrl: './color-filter.component.html',
  styleUrls: ['./color-filter.component.scss']
})
export class ColorFilterComponent {

  dropdownOpen: boolean;
  selectedColor: Color;
  @Output() onColorSelected = new EventEmitter<Color>();

  protected readonly Color = Color;
  protected readonly capitalizeFirstLetter = capitalizeFirstLetter;

  updateColor(color: Color) {
    this.selectedColor = color;
    this.dropdownOpen = false
    this.onColorSelected.emit(this.selectedColor);
  }
}
